/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { MDXProvider } from '@mdx-js/react'
import { Carousel } from 'components/Carousel'
import { Sticky } from 'components/Sticky'
import calcCovidDose from 'lib/calcCovidDose'
import { presets } from './config'
import useWindowSize from 'hooks/useWindowSize'
import { LinkProps } from '@ta-interaktiv/contentbricks/es/link/component'

// TODO Set the correct article ID here
const ARTICLE_ID = '281658773601'
const PARAMETERS: {
  [k in covidDoseParameter]: {
    name: string
    desc?: string | undefined
    value: string | number | number[]
  }[]
} = presets.parameters
const PARAMETERTEXT: {
  [k in covidDoseParameter]: {
    t: JSX.Element | string
    d: JSX.Element | string
  }
} = presets.parameterText
const PARAMETERORDER: covidDoseParameter[] = presets.parameterOrder as covidDoseParameter[]
const SZENARIOS = presets.szenarios

export function AppComponent() {
  const [currentSzenario, setCurrentSzenario] = useState<number>(0)
  const [order, setOrder] = useState<covidDoseParameter[]>(PARAMETERORDER)
  const [config, setConfig] = React.useState<
    { [key in covidDoseParameter]: number | string | number[] }
  >(SZENARIOS[0].data)

  const size = useWindowSize() || 0
  const ismobile = size < 712

  const handleParameterChange = (
    parameter: string,
    value: string | number | number[] | undefined
  ) => {
    if (parameter === 'all') {
      const id = value as number

      SZENARIOS[id] && setConfig(SZENARIOS[id].data)
      setCurrentSzenario(id)
      setOrder(JSON.parse(JSON.stringify(order)))
    } else {
      if (config) {
        console.log(config[parameter], value)
      }
      setConfig({
        ...config,
        ...{
          [parameter]: value
        }
      })
    }
  }

  let result
  try {
    result = calcCovidDose(config)
  } catch (error) {
    console.error(error)
    result = [NaN, NaN]
  }

  const isScenarioActive = SZENARIOS.some(
    s => JSON.stringify(s.data) == JSON.stringify(config)
  )

  return (
    <MDXProvider
      components={{
        a: (props: LinkProps) => <Link {...props} allowWordWrap />
      }}
    >
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />
        <header className='ui vertical  very fitted  segment'>
          <div className='ui ta container'>
            <div className='ui header'>
              <div className='header-sup'>Notre simulateur Covid-19</div>
              <Mdx file={require('text/ed5tuPxCdc9V.mdx')} />
            </div>
          </div>
        </header>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Andreas Moor, Marc Brupbacher, Sebastian Broschinski
              </div>
              <div className='ta updated'>Mis à jour le 8 novembre 2021</div>
            </div>
            <p>
              <Mdx
                className='ta text'
                file={require('text/WacqRxnKdikz.mdx')}
              />
            </p>
          </div>
        </div>
        <div className='ui vertical segment allParams'>
          <div className='ui text container'>
            <h3>Trois scénarios en guise d’exemple</h3>
          </div>
          <div className='ui container szenario'>
            <Carousel
              ismobile={ismobile}
              desc={{
                t: <></>,
                d: <></>
              }}
              parameter='all'
              current={isScenarioActive ? currentSzenario : null}
              type='Szenario'
              elements={SZENARIOS.map(
                (m, i) =>
                  ({
                    name: m.name,
                    desc: m.desc,
                    value: i
                  } as CarouselElement)
              )}
              handleChange={handleParameterChange}
              autoScroll={false}
            />
          </div>
          <div className='ui text container szenarioContainer'>
            {/* <div className='arrowcontainer'>
              <img src={require('images/icons/icons_arrow_down_1.png')} />
            </div> */}
            <div
              className='ownszenario'
              style={{
                opacity: isScenarioActive ? 0 : 1
              }}
            >
              <div className='ui text container'>
                <div className='ta text'>
                  <img
                    src={require('images/icons/icons_arrow.png')}
                    style={{ width: '75px' }}
                  />
                  <br />
                  Vous avez fait vos propres réglages. Retournez aux scénarios prédéfinis ici.
                </div>
              </div>
            </div>

            <div
              className='ta text szenariotext'
              style={{ opacity: isScenarioActive ? 1 : 0 }}
            >
              {SZENARIOS[currentSzenario].text}
            </div>
          </div>
          {config && (
            <Sticky
              isMobile={ismobile}
              result={result}
              timeInRoom={config.timeInRoom as number}
              criticalDose={config.criticalDose as number}
            />
          )}
          <div
            className='ui vertical very fitted segment'
            style={{ marginBottom: '1em' }}
          >
            <div className='ui text container'>
              <div className='ta text calltoaction'>
                <img
                  src={require(`images/icons/icons_action${
                    ismobile ? '' : '_desktop'
                  }.png`)}
                />
                <p>
                Créez votre propre scénario en {ismobile ? <><b>touchant</b> l'un des</> : <><b>cliquant</b> sur les</>} rectangles suivants et découvrez comment le risque d'infection au coronavirus par le biais d’aérosols change selon les différentes situations.
                </p>
              </div>
            </div>
          </div>
          <div className='ui container parameter'>
            {order &&
              order.map((param, i) => {
                return (
                  <Carousel
                    key={i}
                    ismobile={ismobile}
                    desc={PARAMETERTEXT[param]}
                    parameter={param}
                    current={config[param]}
                    elements={PARAMETERS[param]}
                    handleChange={handleParameterChange}
                  />
                )
              })}
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                <Mdx
                  className='ta text'
                  file={require('text/X-cxAIYs6Uoc.mdx')}
                />
              </p>
            </div>
          </div>
        </div>
        <Footer
          mailTo='interactif@tamedia.ch'
          hidePortfolioTeaser
          locale='fr'
          articleId={ARTICLE_ID}
          credits={[
            [
              'Conception et réalisation',
              'Marc Brupacher, Andreas Moor, Sebastian Broschinski'
            ],
            ['Calculs et conseils', 'Michael Riediker'],
            [
              'Collaboration',
              '<a href="https://dreamproduction.com/" target="_blank">Dream Production</a>'
            ]
          ]}
        />
      </div>
    </MDXProvider>
  )
}
